// extracted by mini-css-extract-plugin
export default {"checkbox":"styles_checkbox__qoSVh","checkbox__active":"styles_checkbox__active__p+iRr","checkbox__disabled":"styles_checkbox__disabled__Omszw"};